import React, { useEffect, useRef, useState } from 'react';
import { featureFlags } from 'src/config/featureFlags';
import { HelpSearchInput } from '../../molecules/helpCenter/HelpSearchInput';
import { AskFreyaBanner } from '../../molecules/helpCenter/AskFreyaBanner';
import { GuidedTourSection } from '../../organisms/helpCenter/GuidedTourSection';
import { TopicSidebar } from '../../organisms/helpCenter/TopicSidebar';
import { HelpContent } from '../../organisms/helpCenter/HelpContent';

export const HelpCenterTemplate: React.FC = () => {
  const [activeTopic, setActiveTopic] = useState('Getting Started');
  const topRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <div ref={topRef} className='min-h-screen bg-white'>
      {/* Hero Section */}
      <div className='pb-48 pt-48 px-48 border-b border-neutral-20 bg-neutral-10'>
        <div className='text-center'>
          <h1 className='text-24 font-semibold'>Help Center</h1>
          <p className='text-neutral-60 text-18 font-normal'>Learn how to get the most out of Freya</p>
        </div>

        {featureFlags.SHOW_ASK_FREYA && (
          <div className='mt-42'>
            <HelpSearchInput />
          </div>
        )}

        {featureFlags.SHOW_ASK_FREYA && (
          <div className='mt-32'>
            <AskFreyaBanner />
          </div>
        )}

        <div className='mt-42'>
          <GuidedTourSection />
        </div>
      </div>

      {/* Main Content Section */}
      <div className='relative'>
        <div className='flex bg-white'>
          <TopicSidebar activeTopic={activeTopic} onTopicClick={setActiveTopic} />
          <HelpContent activeTopic={activeTopic} />
        </div>
      </div>
    </div>
  );
};
